import styles from './pianoStickyLink.module.scss';

const PianoStickyLink = () => {
  return <div className={`${styles.stickyLink} piano-sticky-link`}></div>;
};

export default PianoStickyLink;
